//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import ClientId from '@models/ClientId';
import CommunicationType from '@models/RightsCommunicationType';
import { Normalized } from '@utils/normalize';

import { Locales } from 'app/constants/locales/locale';

export interface IRequestRightsState {
  configurations: Normalized<IRightsOption, number>;
  isFetchingConfigurations: boolean;
  areConfigurationsFetched: boolean;
  selectedConfigurationId: number;
  selectedMessageIndex: number;
  isRequestingRights: boolean;
  lastError: unknown;
}

export interface IRightsOption {
  id?: number;
  clientId: ClientId;
  name: string;
  isDefault: boolean;
  isNew?: boolean;
  targetType: RightsRequestTargetType;
  entityId?: string;
  allowCustomRequest: boolean;
  rightsRequestData: {
    data: IRightsRequestDatum[];
  };
}

export interface IRightsRequestDatum {
  message: string;
  approvalPhrase?: string;
  communicationType?: CommunicationType;
  languageCode?: Locales;
}

export enum RightsRequestTargetType {
  CLIENT = 'Client',
  FANREEL = 'Fanreel',
}
